import type { ReviewFormData } from '../../model/review/interfaces';

export const hasFormData = (formState: ReviewFormData, isMember: boolean = false): boolean => {
  // Members get nickname/email auto-filled from their account, so those fields never count
  // as user-entered changes.
  const hasIdentityInput = !isMember && (formState.nickname.trim() !== '' || formState.email.trim() !== '');

  return (
    formState.rating > 0 ||
    formState.title.trim() !== '' ||
    formState.content.trim() !== '' ||
    hasIdentityInput ||
    formState.skinType !== '' ||
    formState.skinConcern !== '' ||
    formState.images.length > 0 ||
    formState.recommend !== '' ||
    formState.ageGroup !== '' ||
    formState.gender !== ''
  );
};

/**
 * An edit opens already filled in, so "unsaved" cannot mean "not empty" — by that measure every
 * edit modal is dirty the moment it opens and closing one always asks to discard. It means moved
 * away from what the review was seeded with. Identity and demographics are left out: the update
 * endpoint does not carry them, so the form never asks for them.
 */
export const hasEditedForm = (formState: ReviewFormData, seeded: ReviewFormData): boolean =>
  formState.rating !== seeded.rating ||
  formState.title.trim() !== seeded.title.trim() ||
  formState.content.trim() !== seeded.content.trim() ||
  formState.skinType !== seeded.skinType ||
  formState.skinConcern !== seeded.skinConcern ||
  formState.images.length > 0 ||
  // Attachments can only be dropped from the seeded list, so the count settles it.
  formState.keptMedia.length !== seeded.keptMedia.length;

export const getInitialFormState = () => ({
  rating: 0,
  title: '',
  content: '',
  nickname: '',
  email: '',
  skinType: '',
  skinConcern: '',
  images: [],
  recommend: '',
  ageGroup: '',
  gender: '',
  keptMedia: [],
});
